import React from "react";

const highlights = [
  {
    iconClass: "fas fa-badge-check",
    text: "Hand Picked Products",
  },
  {
    iconClass: "fas fa-gift",
    text: (
      <>
        Reward Point on Every Purchase
      </>
    ),
  },
  {
    iconClass: "fas fa-bolt",
    text: "Quality Check Products",
  },
  {
    iconClass: "fas fa-check-double",
    text: "Trusted Products",
  },
];

const FooterStrip = () => {
  return (
    <div className="highlight-wrapper border-bottom py-3">
      <div className="highlight-container">
        {highlights.map((item, index) => (
          <div className="highlight-item" key={index}>
            <i className={item.iconClass}></i>
            <div className="text">{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterStrip;
